module.exports = __webpack_public_path__ + "img/leida.c90c09d9.png";